var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subscriptions-settings-component" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _vm.subscriptions.length > 0
            ? _c(
                "div",
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.subscriptions, function(sub) {
                    return _c("div", { key: sub.id, staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-2" }, [
                        _vm._v(
                          _vm._s(_vm.format_date(sub.current_period_start))
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-1" }, [
                        _vm._v(_vm._s(sub.price.interval))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2" }, [
                        _vm._v(_vm._s(_vm.format_plan(sub.price.lookup_key)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-1" }, [
                        _vm._v(_vm._s(_vm.format_price(sub.price.unit_amount)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2" }, [
                        _vm._v(_vm._s(_vm.format_status(sub)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2" }, [
                        _vm._v(_vm._s(_vm.format_date(sub.current_period_end)))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2" }, [
                        _vm.updating
                          ? _c("span", [_vm._v("Updating...")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canBeCancelled(sub) && !_vm.updating
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.updateSubscription(sub.id, {
                                      cancel_at_period_end: true
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Cancel\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canBeRenewed(sub) && !_vm.updating
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.updateSubscription(sub.id, {
                                      cancel_at_period_end: false
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                Renew\n                            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.subscriptions.length == 0 && !_vm.loading
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v("\n                    Currently, there is no active "),
                _c(
                  "a",
                  {
                    staticClass: "sub-link",
                    attrs: { href: "/subscriptions" }
                  },
                  [_vm._v("Plus level\n                    subscription")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                    Getting subscriptions...\n                "
                )
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row bold sub-header" }, [
      _c("div", { staticClass: "col-md-2" }, [_vm._v("Date")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [_vm._v("Interval")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [_vm._v("Plan")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1" }, [_vm._v("Amount")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [_vm._v("Status")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [_vm._v("Current Period")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2" }, [_vm._v("Actions")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }